module.exports = __webpack_public_path__ + "img/home__1fk3——vi.e9900393.png";